import { Head } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  GroupMembers,
  type Member,
  type PendingInvite,
  type RoleOption,
} from "@/features/staff/organization/group-members"
import { OrganizationWorkspaceNav } from "@/features/staff/organization/workspace-nav"
import { t } from "@/lib/i18n"

/**
 * Who is in the group, and who has been offered a place in it.
 *
 * Its own screen rather than a card under the comparison. Membership is
 * configuration and the comparison is a reading of a period; putting them
 * together left the member list sitting under a row of period chips that had
 * nothing to do with it.
 */

type Props = {
  organization: { id: number; name: string }
  canManageOrganization: boolean
  canManageMembers: boolean
  members: Member[]
  invites: PendingInvite[]
  roleOptions: RoleOption[]
  timeZone: string
}

export default function StaffLocationOrganizationMembers({
  organization,
  canManageOrganization,
  canManageMembers,
  members,
  invites,
  roleOptions,
  timeZone,
}: Props) {
  const title = t("ui.react.pages.staff.location.organization.members.page_title")

  return (
    <>
      <Head title={`${title} · ${organization.name}`} />

      <MainContainer size="md">
        <OrganizationWorkspaceNav
          current="members"
          organizationName={organization.name}
          canManageOrganization={canManageOrganization}
        />

        <GroupMembers
          members={members}
          invites={invites}
          roleOptions={roleOptions}
          canManageMembers={canManageMembers}
          timeZone={timeZone}
        />
      </MainContainer>
    </>
  )
}


StaffLocationOrganizationMembers.layout = (page: React.ReactNode) => <StaffLayout>{page}</StaffLayout>
